<template>
  <div id="Membership">
    <h1>Member Profile</h1>
    <div class="line"></div>

    <template v-if="!submitStatus">
      <p>Personalize your Season Member Experience</p>

      <div class="memberForm">
        <div class="radioButtons">
          <label>Are you planning on using these tickets for a business purpose?</label>
          <div class="radioButton">
            <input type="radio" id="yes" name="gender" value="yes" v-model="formValues.businessPurpose">
            <label class="small" for="yes">Yes</label>
          </div>
          <div class="radioButton">
            <input type="radio" id="no" name="gender" value="no"  v-model="formValues.businessPurpose">
            <label class="small" for="no">No</label>
          </div>
        </div>

        <br />
        
        <label for="player">Who is your favorite Rays Player?</label>
        <br />
        <input type="text" v-model="formValues.favePlayer" />

        <br />

        <label for="player">Who is your favorite former Rays Player?</label>
        <br />
        <input type="text" v-model="formValues.faveFormerPlayer" />

        <br />

        <label for="player">Will you be celebrating any special occasions at Tropicana Field during the upcoming season? If so, what is the special occasion and what date will you be celebrating at the ballpark?</label>
        <br />
        <input type="text" v-model="formValues.celebrating" />

        <br />

        <label for="player">What is your birthday?</label>
        <br />
        <input type="date" v-model="formValues.birthday" />

        <br />

        <div class="submitBtn">
          <a @click="submitForm">Submit Your Profile</a>
        </div>
      </div>
    </template>
    <template v-else>
      <p>Your Personalize Membership Form has been sent.</p>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "Membership",
  data() {
    return {
      submitStatus: false,
      formValues: {
        businessPurpose: "yes",
        favePlayer: "",
        faveFormerPlayer: "",
        celebrating: "",
        birthday: "",
      }
    }
  },
  methods: {
    async submitForm(){
      if(!this.formValues.favePlayer || !this.formValues.faveFormerPlayer || !this.formValues.celebrating || !this.formValues.birthday || !this.formValues.businessPurpose){
       this.$swal(
          "Error!",
          "Please fill in all the fields!",
          "error"
        );
       return;
      }

      const response = await axios.post(
        process.env.VUE_APP_BASE_URL + "/api/router/Forms.php",
        {
          action: 'submitSurvey',
          prefix: 'rays2021',
          accountId: this.$store.state.global.userInfo.accountId,
          purl: this.$store.state.global.userInfo.purl,
          timestamp: new Date(),
          formValues: JSON.stringify(this.formValues)
        }
      );
      if(response.data.status === 'success'){
        this.submitStatus = true;
        this.formValues.businessYes = false;
        this.formValues.businessNo = false;
        this.formValues.favePlayer = "";
        this.formValues.faveFormerPlayer = "";
        this.formValues.celebrating = "";
        this.formValues.birthday = "";
        this.$swal(
          "Success!",
          "You have successfully sent your Personalize Membership Form!",
          "success"
        );
      }
    }
  },
  mounted(){
    let userInfo = this.$store.state.global.userInfo;
    this.submitStatus = userInfo.formValues ? true : false;
    window.console.log('purl',  this.$store.state.global.userInfo.purl);
  }
}
</script>

<style lang="scss" scoped>
#Membership {
  width: 50%;
  margin: auto;
	margin-bottom: 100px;
  &.hide{
    display: none;
  }
	@media only screen and (max-width: $lg) {
		width: 90%;
	}
	h1 {
		font-family: 'UniversLTStd-UltraCn';
		text-transform: uppercase;
		color: $dark-blue;
		font-size: 50px;
    @media only screen and (max-width: $sm) {
      font-size: 42px;
    }
	}
	p {
    font-family: 'UniversLTStd';
    margin-bottom: 30px;
  }
  .line{
    background-color: $yellow;
    width: 190px;
    height: 3px;
    margin: 10px 0 20px 0;
  }
  .memberForm {
    .radioButtons {
      display: flex;
      flex-direction: row;
      @media only screen and (max-width: $sm) {
        flex-direction: column;
      }
      .radioButton {
        width: 30px;
        text-align: center;
        display: flex;
        flex-direction: column;
        input {
          position: relative;
          left: 8px;
        }
      }
    }
    label {
      font-family: 'UniversLTStd-Bold';
      color: $dark-blue;
    }
    input[type=text], input[type=date] {
      width: 100%;
      border: 1px solid #ccc;
      border-radius: 3px;
      margin-bottom: 25px;
      padding: 5px;
    }
  }
  .submitBtn {
    margin-top: 20px;
    a {
      background-color: $dark-blue;
      font-family: 'UniversLTStd-Bold';
      font-size: 14px;
      text-transform: uppercase;
      padding: 15px 35px;
      color: #fff;
      border-radius: 25px;
      cursor: pointer;
      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>